/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Mk_Sol_Lembaga_F3Inputs */

const en_mk_sol_lembaga_f3 = /** @type {(inputs: Mk_Sol_Lembaga_F3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Google Workspace, chat groups, forms, spreadsheets`)
};

const id_mk_sol_lembaga_f3 = /** @type {(inputs: Mk_Sol_Lembaga_F3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Google Workspace, grup chat, formulir, spreadsheet`)
};

/**
* | output |
* | --- |
* | "Google Workspace, chat groups, forms, spreadsheets" |
*
* @param {Mk_Sol_Lembaga_F3Inputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const mk_sol_lembaga_f3 = /** @type {((inputs?: Mk_Sol_Lembaga_F3Inputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Mk_Sol_Lembaga_F3Inputs, { locale?: "en" | "id" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_mk_sol_lembaga_f3(inputs)
	return en_mk_sol_lembaga_f3(inputs)
});